const CONTACT_US_EMAIL = 'support@lentli.no'

export { CONTACT_US_EMAIL }
export default CONTACT_US_EMAIL
